import React, { useMemo } from 'react';
import { JourneyMenuPropsInterface } from 'src/common/JourneyMenu';

import { StepRegularIcon } from 'src/monet/icons';

import { getAllNodes } from 'src/utils/journey';
import { Node } from 'src/common/interfaces/node.interface';
import { SmallPanel } from 'src/common/ui/small-panel';
import { useSharePanelStore } from 'src/common/store/share.store';

interface Props
  extends Pick<
    JourneyMenuPropsInterface,
    'openRef' | 'closeRef' | 'renderOrigin' | 'onOpen' | 'onClose' | 'placement' | 'popperClassName'
  > {
  onBack?: () => void;
  onClickItem: (node: Node) => void;
}

export const ShareThumbnailPickFromStepPanel = ({ onBack, onClickItem, ...popoverProps }: Props) => {
  const journey = useSharePanelStore((state) => state.sharedJourney);
  const stepsWithThumbnails = useMemo(() => {
    return getAllNodes(journey).filter((node: Node) => {
      return (
        (node.thumbnail && node.thumbnail.url) ||
        (node.content_type === 'external_link' && node.external_link?.meta_image_url)
      );
    });
  }, [journey]);

  return (
    <SmallPanel
      openAfterMount
      containerClassName='max-h-[384px] overflow-y-auto'
      hasBackButton
      onBack={onBack}
      {...popoverProps}
    >
      <div className='flex flex-col space-y-md'>
        <span className='text-bedrock-p text-bedrock-black'>
          Pick another Step in your Journey and we’ll use that thumbnail
        </span>
        {stepsWithThumbnails.map((step: Node) => (
          <div
            key={step.id}
            className='flex items-start space-x-sm cursor-pointer hover:opacity-80'
            onClick={() => onClickItem(step)}
          >
            <div className='flex flex-shrink-0'>
              <StepRegularIcon />
            </div>
            <div className='text-bedrock-p text-bedrock-black'>{step.name}</div>
          </div>
        ))}
      </div>
    </SmallPanel>
  );
};
